export default __webpack_public_path__ + "static/media/logo.5e32de1a.png";